import { getSourceType } from '@/utils/amend/getAmendSourceType'

/** Same shape as persisted `ctapData` / legacy getCommonClevertapParams base */
export type AmendmentClevertapBasePayload = {
  domain: string
  timestamp: string
  email_id: string
  amend_source: 'accounts' | 'hq'
  platform: string
  trip_ID: string
  is_SMS: boolean
}

export function buildAmendmentClevertapBasePayload(
  tripId: string,
  isSms: boolean,
  userEmail: string
): AmendmentClevertapBasePayload {
  const amend_source: 'accounts' | 'hq' = getSourceType() === 'hq' ? 'hq' : 'accounts'
  return {
    domain: typeof window !== 'undefined' ? window.location.hostname : '',
    timestamp: new Date().toString(),
    email_id: userEmail,
    amend_source,
    platform: 'desktop',
    trip_ID: `id_${tripId}`,
    is_SMS: isSms,
  }
}
